import { GridSortItem } from "@mui/x-data-grid-pro"
import { setLocalStorageValues, TableLocalStorageKey } from "../helpers"
import { useTableContext } from "../provider"

export const useSorting = () => {

  const ctx = useTableContext()
  const { tableId } = ctx.props

  const onSortModelChange = (model: GridSortItem[]) => {
    if (model.length !== ctx.data.state.sortModel.length) return
    ctx.data.api.setSort(model)
    setLocalStorageValues(tableId, TableLocalStorageKey.sortModel, model)
  }

  return {
    onSortModelChange
  }
}
